import React from 'react'

import Table from '../../../../UI/Table/Table'
import { Delete } from '@material-ui/icons'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

const selectedItemPreview = ({ targetItems, itemDeleted, translate }) => {
  const rowActions = [
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: translate('removeItem'),
      onClick: (event, rowData) => itemDeleted(rowData.item_id)
    }
  ]

  const tableStructure = [
    {
      field: 'structure_name',
      title: translate('structure'),
      type: 'string'
    },
    {
      field: 'item_name',
      title: translate('appraisalItem'),
      type: 'string',
      render: rowData =>
        `${rowData.item_code ? `${rowData.item_code} - ${rowData.item_name}` : rowData.item_name}`
    }
  ]

  return (
    <Table
      title={translate('example')}
      search={false}
      detailPanel={null}
      structure={tableStructure}
      rowActions={rowActions}
      paginationDisabled={true}
      recordData={targetItems}
    />
  )
}

export default withTranslate(selectedItemPreview)
